import { datadogRum } from '@datadog/browser-rum';
import { VERSION } from '../version';
import store from '../redux/store/configureStore';
import { USER_TYPES } from 'enums';

export function initializeDatadogRum(user) {
  const datadogRumAppId = window.ambulnzConfig.constants.DATADOG_RUM_APP_ID;
  const datadogRumEnable = window.ambulnzConfig.constants.DATADOG_REQUESTER_RUM_ENABLE;
  const datadogRumClientToken = window.ambulnzConfig.constants.DATADOG_RUM_CLIENT_TOKEN;
  const datadogRumEnv = window.ambulnzConfig.constants.DATADOG_RUM_ENV;
  const datadogRumSampleRate = Number(window.ambulnzConfig.constants.DATADOG_REQUESTER_RUM_SAMPLE_RATE);
  const datadogRumSessionSampleRate = Number(window.ambulnzConfig.constants.DATADOG_REQUESTER_RUM_SESSION_SAMPLE_RATE);
  const selectedAccount = store.getState().userAccount.selectedUserAccount;
  if (datadogRumEnable) {
    datadogRum.init({
      applicationId: datadogRumAppId,
      clientToken: datadogRumClientToken,
      site: 'datadoghq.com',
      service: 'requester',
      env: datadogRumEnv,
      version: VERSION,
      sessionSampleRate: datadogRumSampleRate,
      sessionReplaySampleRate: datadogRumSessionSampleRate,
      forwardErrorsToLogs: true,
      forwardConsoleLogs: ['all'],
      defaultPrivacyLevel: 'mask-user-input',
      allowedTracingUrls: [
        (url) => {
          // Exclude SSO endpoints to prevent CORS errors
          if (url.includes('sso.ambulnz-dev.net') || url.includes('sso.ambulnz.net')) {
            return false;
          }
          // Match other ambulnz domains
          return /^https:\/\/[^\/]+\.(ambulnz-dev\.net|ambulnz\.net|ca1\.proda6-dev\.net|us1\.proda6\.net)/.test(url);
        },
      ],
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
      storeContextsAcrossPages: true,
      usePartitionedCrossSiteSessionCookie: true,
      beforeSend: event => {
        // Stamp each event with the request open in this tab so RUM sessions can be found by request id.
        // Read from the store at send time (not global context, which storeContextsAcrossPages syncs across tabs).
        const requestId = store.getState().requests.request?.id;
        if (requestId != null) {
          event.context = { ...event.context, requestId: String(requestId) };
        }
        return true;
      },
    });

    datadogRum.setUser({
      id: user.id,
      email: user.email,
      name: `${user.firstName} ${user.lastName}`,
      role:
        user.userType === USER_TYPES.DISPATCHER
          ? 'Dispatcher'
          : user.userType === USER_TYPES.REQUESTER
          ? 'Requester'
          : '',
      account: selectedAccount ? selectedAccount : '',
    });
  }
}

export function trackEvent(eventName, context = {}) {
  if (!window.ambulnzConfig.constants.DATADOG_REQUESTER_RUM_ENABLE || typeof datadogRum?.addAction !== 'function')
    return;
  datadogRum.addAction(eventName, context);
}
